<template>
  <div class="app-nav-top">
    <nav class="flex text-white" style="background-color:rgba(0,0,0,0.5); border-bottom-width:0;">
      <button
        type="button"
        class="btn h-header w-header flex items-center justify-center"
        @click.stop="$emit('cancel')"
      >
        <CancelIcon fill-color="currentColor" />
      </button>
      <div
        v-if="showSaveDraft"
        class="flex flex-1 items-center overflow-x-hidden justify-center"
      >
        <h2 class="truncate" style="margin:0">{{ title }}</h2>
      </div>
      <button
        v-if="showSaveDraft"
        type="button"
        class="btn h-header w-header flex items-center justify-center"
        @click.stop="$emit('save')"
      >
        <CheckSaveIcon />
      </button>
    </nav>
    <div class="h-header"></div>
  </div>
</template>

<script>
  import CancelIcon from '@/_legacy/components/Icons/CancelIcon.vue';
  import CheckSaveIcon from '@/_legacy/components/Icons/CheckSaveIcon.vue';

  export default {
    components: {
      CancelIcon,
      CheckSaveIcon,
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      showSaveDraft: {
        type: Boolean,
        default: true,
      },
    },
  };

</script>
